import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { FooterComponent } from './footer.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TermsDialogComponent } from './terms-dialog/terms-dialog.component';

@NgModule({
  declarations: [FooterComponent, TermsDialogComponent],
  imports: [CommonModule, MatTooltipModule, MatDialogModule, MatButtonModule],
  exports: [FooterComponent],
  providers: [],
})
export class footerModule {}
